import { render, staticRenderFns } from "./BuyButton.vue?vue&type=template&id=7a356c5e&"
import script from "./BuyButton.vue?vue&type=script&lang=js&"
export * from "./BuyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports